export default "__VITE_ASSET__BzKxCM3A__"